/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DefaultTimeFormatEnum } from './DefaultTimeFormatEnum';
import type { DigestCadenceEnum } from './DigestCadenceEnum';
import {
    DigestCadenceEnumFromJSON,
    DigestCadenceEnumFromJSONTyped,
    DigestCadenceEnumToJSON,
    DigestCadenceEnumToJSONTyped,
} from './DigestCadenceEnum';

/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Membership
     */
    readonly userId: number;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    readonly entityId: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    readonly firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    readonly lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    readonly email: string;
    /**
     * 
     * @type {string}
     * @memberof Membership
     */
    readonly displayName: string;
    /**
     * Return authentication provider ('google' for Google OAuth, None otherwise).
     * @type {string}
     * @memberof Membership
     */
    readonly provider: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    notifyOnMention?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    notifyOnOwnedObjects?: boolean;
    /**
     * Free-text instructions for the AI agent in this org
     * @type {string}
     * @memberof Membership
     */
    agentGuidance?: string;
    /**
     *
     * @type {DigestCadenceEnum}
     * @memberof Membership
     */
    digestCadence?: DigestCadenceEnum;
    /**
     * Per-member time-of-day display format; blank ('') falls back to the org's default_time_format.
     * @type {string}
     * @memberof Membership
     */
    timeFormat?: DefaultTimeFormatEnum | '';
    /**
     *
     * @type {string}
     * @memberof Membership
     */
    readonly deactivatedAt?: string | null;
    /**
     *
     * @type {string}
     * @memberof Membership
     */
    readonly lastLogin?: string | null;
    /**
     * Membership kind. Hand-added bridge pending a full client regen
     * (a real regen would emit a generated MemberKind enum). Read-only.
     * Kept optional to match the defensive null-safety pattern used by the other hand-bridged fields (deactivatedAt, lastLogin); the backend member_kind field always has a value today (see apps/orgs/models.py).
     * @type {string}
     * @memberof Membership
     */
    readonly memberKind?: 'member' | 'partner' | 'viewer';
}



/**
 * Check if a given object implements the Membership interface.
 */
export function instanceOfMembership(value: object): value is Membership {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}

export function MembershipFromJSON(json: any): Membership {
    return MembershipFromJSONTyped(json, false);
}

export function MembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): Membership {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['user_id'],
        'entityId': json['entity_id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'email': json['email'],
        'displayName': json['display_name'],
        'provider': json['provider'],
        'notifyOnMention': json['notify_on_mention'] == null ? undefined : json['notify_on_mention'],
        'notifyOnOwnedObjects': json['notify_on_owned_objects'] == null ? undefined : json['notify_on_owned_objects'],
        'agentGuidance': json['agent_guidance'] == null ? undefined : json['agent_guidance'],
        'digestCadence': json['digest_cadence'] == null ? undefined : DigestCadenceEnumFromJSON(json['digest_cadence']),
        'timeFormat': json['time_format'] == null ? undefined : json['time_format'],
        'deactivatedAt': json['deactivated_at'] == null ? undefined : json['deactivated_at'],
        'lastLogin': json['last_login'] == null ? undefined : json['last_login'],
        'memberKind': json['member_kind'] == null ? undefined : json['member_kind'],
    };
}

  export function MembershipToJSON(json: any): Membership {
      return MembershipToJSONTyped(json, false);
  }

  export function MembershipToJSONTyped(value?: Omit<Membership, 'id'|'userId'|'entityId'|'firstName'|'lastName'|'email'|'displayName'|'provider'|'deactivatedAt'|'lastLogin'|'memberKind'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notify_on_mention': value['notifyOnMention'],
        'notify_on_owned_objects': value['notifyOnOwnedObjects'],
        'agent_guidance': value['agentGuidance'],
        'digest_cadence': DigestCadenceEnumToJSON(value['digestCadence']),
        'time_format': value['timeFormat'],
    };
}

